/*
 * Usage:
 * 	var map = document.getElementById( 'myMapId' )
	var image = document.getElementById( 'myImageId' )
	new ResponsiveImageMap( map, image, 800 )
 */
class ResponsiveImageMap {
	constructor( map, img, width ) {
		this.img = img
		this.originalWidth = width
		this.areas = []

		// Ensure this is only called once on the element:
		if ( map.classList.contains( 'is-set' ) ) {
			return
		}

		map.classList.add( 'is-set' )

		for ( const area of map.getElementsByTagName( 'area' ) ) {
			this.areas.push({
				element: area,
				originalCoords: area.coords.split( ',' )
			})
		}

		window.addEventListener( 'resize', e => this.resize( e ) )
		this.resize()
	}

	resize() {
		const ratio = this.img.offsetWidth / this.originalWidth

		for ( const area of this.areas ) {
			const newCoords = []

			for ( const originalCoord of area.originalCoords ) {
				newCoords.push( Math.round( originalCoord * ratio ) )
			}

			area.element.coords = newCoords.join( ',' )
		}

		return true
	}
}

export default ResponsiveImageMap



// WEBPACK FOOTER //
// ./utilities/ResponsiveImageMap.jsx